export default "__VITE_ASSET__6_jWO8Re__"